import React from "react";
import {Route, Switch} from "react-router-dom";
import FormLogin from "./components/FormLogin";
import NotFound from "./components/NotFound";
import Importaciones from "./pages/Importaciones";
import Ubicaciones from "./pages/Ubicaciones";
import RangosTag from "./pages/RangosTag";
import ConsultarTag from "./pages/ConsultarTag";
import PrivateRoute from './components/PrivateRoute';
import Avance from "./pages/Avance";
import TagsAvance from "./pages/TagsAvance";
import DetalleTag from "./pages/DetalleTag";
import Diferencias from "./pages/Diferencias";
import DetalleDiferencias from "./pages/DetalleDifJerarquia";
import DetalleDiferenciaProducto from "./pages/DetalleDifProducto";
import Reportes from "./pages/Reportes";
//import Inventarios from "./pages/Inventarios";
import Inventarios from "./pages/InventariosMod";
import AgregarInventario from "./pages/AgregarInventario";
import Exportaciones from "./pages/Exportaciones";
import ExportacionesPanel from "./pages/ExportacionesPanel";
import DetalleConteo from "./pages/DetalleConteo";
import Conflictos from "./pages/Conflictos";
import DetalleTagConflictos from "./pages/DetalleTagConflictos";
import Observaciones from "./pages/Observaciones";
import Historial from "./pages/Historial";
import Eliminados from "./pages/Eliminados";
import DetalleEliminados from "./pages/DetalleEliminados";
import BarcodeScanner from "./components/BarcodeScanner";
import Modificaciones from "./pages/Modificaciones";
import TagsValidados from "./pages/TagsValidados";
import DetalleDescargaTag from "./pages/DetalleDescargaTag";
import ValidacionConteo from "./pages/ValidacionConteo";
import ResumenValidacion from "./pages/ResumenValidacion";
import ConsultarCodigo from "./pages/ConsultarCodigo";
import DetalleProducto from "./pages/DetalleProducto";
import RecountSheets from "./pages/RecountSheets";
import PanelSodimacSemanal from "./pages/PanelSodimacSemanal";
import PanelSodimacDiario from "./pages/PanelSodimacDiario";
import PanelSodimacHistorico from "./pages/PanelSodimacHistorico";
import Conflictos_2 from "./pages/Conflictos_2";
import AuditoriaVisual from "./pages/AuditoriaVisual";
import RNR from "./pages/RNR";
import ValidadoresCliente from "./pages/ValidadoresCliente";
//import HighDollar from "./pages/HighDollar";
import HighDollar from "./pages/HighDollarConTotal";
import Dashboard from "./pages/Dashboard";
import Rendimiento from "./pages/Rendimiento";
import DiferenciasPorUbicacion from "./pages/DiferenciasPorUbicacion";
import PasillosParaAuditar from "./pages/PasillosParaAuditar";
import Mandatorios from "./pages/Mandatorios";
//import RevisionReportes from "./pages/RevisionReportes";
import RevisionReportes from "./pages/RevisionReportesWalmart";
import PanelGeneral from "./pages/PanelGeneral";
import CaminadoTickets from "./pages/CaminadoTickets";
import ConsultarOperador from "./pages/ConsultarOperador";
import DetalleOperador from "./pages/DetalleOperador";
import ConteosSignificativos from "./pages/ConteosSignificativos";
import CantidadesXRevisar from "./pages/CantidadesXRevisar";
import ProductividadOperadores from "./pages/ProductividadOperadores";
import CambiosCodigosValidados from "./pages/CambiosCodigosValidados";
import CantidadPorCodigoValidado from "./pages/CantidadPorCodigoValidado";
import PanelAuditorias from "./pages/PanelAuditorias";
import PanelAuditoriasAltillo from "./pages/PanelAuditoriasAltillo";
import PanelAuditoriasVisual from "./pages/PanelAuditoriasVisual";
import PanelAuditoriasAltilloDetalle from "./pages/PanelAuditoriasAltilloDetalle";
import RevisionPrecios from "./pages/RevisionPrecios";
import ControlRespaldos from "./pages/ControlRespaldos";
import GestionArchivos from "./pages/GestionArchivos";

class App extends React.Component{
    render() {
        return (
            <div>
                <Switch>
                    <Route exact path="/">
                        <FormLogin/>
                    </Route>
                    <PrivateRoute exact path="/importaciones" component={Importaciones}/>
                    <PrivateRoute exact path="/ubicaciones" component={Ubicaciones}/>
                    <PrivateRoute exact path="/rangos_tag" component={RangosTag}/>
                    <PrivateRoute exact path="/consultar_tag" component={ConsultarTag}/>
                    <PrivateRoute exact path="/detalles_tag/:tag" component={DetalleTag}/>
                    <PrivateRoute exact path="/avance" component={Avance}/>
                    <PrivateRoute exact path="/tags_avance/:tipo/:ubicacion/:descripcion" component={TagsAvance}/>
                    <PrivateRoute exact path="/diferencias" component={Diferencias}/>
                    <PrivateRoute exact path="/detalle_diferencia/:tipo/:id/:cantidad/:filtro" component={DetalleDiferencias}/>
                    <PrivateRoute exact path="/detalle_diferencia_producto/:idProducto/:origen" component={DetalleDiferenciaProducto}/>
                    <PrivateRoute exact path="/reportes" component={Reportes}/>
                    <PrivateRoute exact path="/inventarios" component={Inventarios}/>
                    <PrivateRoute exact path="/agregar_inv" component={AgregarInventario}/>
                    <PrivateRoute exact path="/exportar" component={Exportaciones}/>
                    <PrivateRoute exact path="/detalle_conteo/:tipo/:id_o_barra/:tag/:id_codigo_tipo" component={DetalleConteo}/>
                    <PrivateRoute exact path="/conflictos" component={Conflictos}/>
                    <PrivateRoute exact path="/detalles_conflictos/:tag" component={DetalleTagConflictos}/>
                    <PrivateRoute exact path="/detalles_descarga_tag/:tag/:id_archivo" component={DetalleDescargaTag}/>
                    <PrivateRoute exact path="/observaciones" component={Observaciones}/>
                    <PrivateRoute exact path="/historial" component={Historial}/>
                    <PrivateRoute exact path="/eliminados" component={Eliminados}/>
                    <PrivateRoute exact path="/detalle_eliminados/:tag" component={DetalleEliminados}/>
                    <PrivateRoute exact path="/scanner" component={BarcodeScanner}/>
                    <PrivateRoute exact path="/modificaciones" component={Modificaciones}/>
                    <PrivateRoute exact path="/tags_validados" component={TagsValidados}/>
                    <PrivateRoute exact path="/validacion_conteo" component={ValidacionConteo}/>
                    <PrivateRoute exact path="/resumen_validacion" component={ResumenValidacion}/>
                    <PrivateRoute exact path="/consultar_codigo" component={ConsultarCodigo}/>
                    <PrivateRoute exact path="/detalle_producto/:codigo" component={DetalleProducto}/>
                    <PrivateRoute exact path="/recount_sheets" component={RecountSheets}/>
                    <PrivateRoute exact path="/panel_sodimac_semanal" component={PanelSodimacSemanal}/>
                    <PrivateRoute exact path="/panel_sodimac_diario" component={PanelSodimacDiario}/>
                    <PrivateRoute exact path="/panel_sodimac_historico" component={PanelSodimacHistorico}/>
                    <PrivateRoute exact path="/conflictos_2" component={Conflictos_2}/>
                    <PrivateRoute exact path="/rnr" component={RNR}/>
                    <PrivateRoute exact path="/auditoria_visual" component={AuditoriaVisual}/>
                    <PrivateRoute exact path="/high_dollar" component={HighDollar}/>
                    <PrivateRoute exact path="/validadores_cliente" component={ValidadoresCliente}/>
                    <PrivateRoute exact path="/dashboard" component={Dashboard}/>
                    <PrivateRoute exact path="/rendimiento" component={Rendimiento}/>
                    <PrivateRoute exact path="/diferencias_por_ubicacion" component={DiferenciasPorUbicacion}/>
                    <PrivateRoute exact path="/pasillos_para_auditar" component={PasillosParaAuditar}/>
                    <PrivateRoute exact path="/mandatorios" component={Mandatorios}/>
                    <PrivateRoute exact path="/revision_reportes" component={RevisionReportes}/>
                    <PrivateRoute exact path="/panel_general" component={PanelGeneral}/>
                    <PrivateRoute exact path="/caminado_tickets" component={CaminadoTickets}/>
                    <PrivateRoute exact path="/consultar_operador" component={ConsultarOperador}/>
                    <PrivateRoute exact path="/detalle_operador/:operador" component={DetalleOperador}/>
                    <PrivateRoute exact path="/conteos_significativos" component={ConteosSignificativos}/>
                    <PrivateRoute exact path="/cantidades_revisar" component={CantidadesXRevisar}/>
                    <PrivateRoute exact path="/datos_productividad" component={ProductividadOperadores}/>
                    <PrivateRoute exact path="/cambios_codigos_validados" component={CambiosCodigosValidados}/>
                    <PrivateRoute exact path="/cantidad_por_codigo_validado" component={CantidadPorCodigoValidado}/>
                    <PrivateRoute exact path="/exportaciones_panel" component={ExportacionesPanel}/>
                    <PrivateRoute exact path="/panel_auditorias" component={PanelAuditorias}/>
                    <PrivateRoute exact path="/panel_auditorias_visual" component={PanelAuditoriasVisual}/>
                    <PrivateRoute exact path="/panel_auditorias_altillo" component={PanelAuditoriasAltillo}/>
                    <PrivateRoute exact path="/panel_auditorias_altillo/:centro/:mes" component={PanelAuditoriasAltilloDetalle}/>
                    <PrivateRoute exact path="/revision_precios" component={RevisionPrecios}/>
                    <PrivateRoute exact path="/control_respaldos" component={ControlRespaldos}/>
                    <PrivateRoute exact path="/gestion_archivos" component={GestionArchivos}/>
                    <Route component={NotFound} />
                </Switch>
            </div>
        );
    }
}

export default App;